export const listForms = (state) => state.forms;
export const singleForm = (state) => state.single_form;
